export default __webpack_public_path__ + "0acef6679b54482b9deac26017aee228.svg";